export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl p-8 md:p-12 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-accent-500/20 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-10 w-48 h-48 bg-background-50/10 rounded-full blur-3xl"></div>

          <div className="relative flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50">移动端入口</h2>
              <p className="mt-4 text-sm md:text-base text-background-50/80 leading-relaxed max-w-lg">
                随时随地畅享吃瓜体验！将911爆料网添加到手机桌面，即可像使用App一样快速访问。
                支持iOS和Android设备，无需下载安装，即点即用，流量消耗极低。
              </p>
              <div className="mt-6 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
                <div className="flex items-center gap-3 bg-background-50/15 backdrop-blur-sm rounded-xl px-5 py-3 border border-background-50/20">
                  <div className="w-10 h-10 flex items-center justify-center">
                    <i className="ri-apple-fill text-2xl text-background-50"></i>
                  </div>
                  <div className="text-left">
                    <div className="text-xs text-background-50/60">iOS 用户</div>
                    <div className="text-sm text-background-50 font-medium whitespace-nowrap">添加到主屏幕</div>
                  </div>
                </div>
                <div className="flex items-center gap-3 bg-background-50/15 backdrop-blur-sm rounded-xl px-5 py-3 border border-background-50/20">
                  <div className="w-10 h-10 flex items-center justify-center">
                    <i className="ri-android-fill text-2xl text-background-50"></i>
                  </div>
                  <div className="text-left">
                    <div className="text-xs text-background-50/60">Android 用户</div>
                    <div className="text-sm text-background-50 font-medium whitespace-nowrap">添加到主屏幕</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex-shrink-0 w-48 h-48 md:w-56 md:h-56 bg-background-50/10 rounded-3xl border border-background-50/20 flex items-center justify-center">
              <div className="text-center">
                <i className="ri-smartphone-line text-5xl text-background-50"></i>
                <p className="mt-3 text-background-50/70 text-sm font-medium">PWA 应用</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}